<template>
  <div>
    <div class="toolbar">
      <el-switch v-model="$store.state.expand" @change="expandTable" class="mr10"/>
      <TopicSearch @change="fetchData" ref="search" style="display:inline-block;"></TopicSearch>
      <el-button type="primary" @click="createForm" style="margin-left:10px;">添加猜词</el-button>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      @sort-change="handleSort"
      :default-expand-all="$store.state.expand"
      :row-key="getRowKeys"
      :expand-row-keys="expands"
    >
      <el-table-column type="expand" width="30">
        <template v-slot="scope">
          <item-hints-list :collections="scope.row.hints"></item-hints-list>
        </template>
      </el-table-column>
      <!-- <el-table-column type="selection" width="60"></el-table-column> -->
      <el-table-column prop="id" label="编号" sortable="custom" width="100"></el-table-column>
      <el-table-column prop="level" label="级别" sortable="custom" width="100"></el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="pinyin" label="拼音"></el-table-column>
      <el-table-column label="词性">
        <template v-slot="item">
          <el-tag class="fs18" v-for="(tag, key) in item.row.grammars" :key="key" size="medium">{{tag.name}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="memo" label="内部备注"></el-table-column>
      <!-- <el-table-column prop="status" label="状态"></el-table-column> -->
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="updateForm(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
          <el-button @click="handleAddHints(scope)" type="text" size="small">添加提示</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-if="total>pageSize"
    >
    </el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%">
      <ItemForm ref="form" :itemType="itemType"></ItemForm>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitleHints" :visible.sync="dialogVisibleHints" width="60%">
      <ItemHintsForm ref="formHints"></ItemHintsForm>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleHints = false">取 消</el-button>
        <el-button type="primary" @click="submitFormHints">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ItemForm from './ItemForm'
import table from './../../components/mixins/table.js'
import TopicSearch from './TopicSearch'
import ItemHintsList from './ItemHintsList'
import ItemHintsForm from './ItemHintsForm'

export default {
  mixins:[table],
  data () {
    return {
      multipleSelection: [],
      itemType: 'word',
      dialogTitle: '添加猜词',
      dialogVisible: false,
      dialogTitleHints: '添加 Tips',
      dialogVisibleHints: false,
      createHintsIndex: null,
      fetchUrl: 'talk_item_list',
      expands: [],
      expand: true,
    }
  },
  components: { ItemForm, TopicSearch, ItemHintsList, ItemHintsForm },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handleFetchConfig (config) {
      if (this.$refs.search) {
        Object.assign(config.params, {
          "filter[type]": this.itemType,
          "filter[status]": null,
          "filter[and][0][level]": this.$refs.search.level || null,
          "filter[and][0][category]": this.$refs.search.category || null,
          "filter[and][1][or][0][title][like]": this.$refs.search.search || null,
          "filter[and][1][or][1][pinyin][like]": this.$refs.search.search || null
        })
      }
    },
    createForm () {
      this.dialogVisible = true
      setTimeout(() => {
        this.$refs.form.reset({
          type: this.itemType,
          status: 0
        })
      }, 10)
    },
    submitForm () {
      this.$refs.form.submit().then(res => {
        this.dialogVisible = false
        this.fetchData()
        // this.$refs.form.reset()
      })
    },
    updateForm (item) {
      this.dialogVisible = true
      this.dialogTitle = '编辑话题'
      setTimeout(() => {
        this.$refs.form.reset(item)
      }, 10)
    },
    handleDelete (item) {
      this.$confirm('确定要删除吗?', '重要提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.$http.delete(this.$urls.talk_item_delete, {
          params: {id: item.id}
        }).then(() => {
          this.fetchData()
        })
      })
    },
    submitFormHints () {
      this.$refs.formHints.submit().then(res => {
        this.dialogVisibleHints = false
        this.tableData[this.createHintsIndex].hints.push(this.$refs.formHints.form)
      })
    },
    handleAddHints (scope) {
      this.dialogVisibleHints = true
      this.createHintsIndex = scope.$index
      setTimeout(() => {
        this.$refs.formHints.reset({
          item_id: scope.row.id
        })
      }, 10)
    },
    expandTable (val) {
      if (val) {
        this.expands = this.tableData.map(item => item.id);
      } else {
        this.expands = [];
      }
      this.$store.state.expand = val;
    },
    getRowKeys(row){
      return row.id
    },
  }
}
</script>
<style lang="scss" scoped>
  .mr10{
    margin-right: 10px;
  }
  .ml10{
    margin-left: 10px;
  }
</style>